'use client'

import React from 'react'
import { useTranslations } from 'next-intl'

import { HOLIDAY_PACKAGE_SORT, type HolidayPackageSort } from '@/src/constants/holidays'

import PackageSortControl, { type PackageSortOption } from './packageSortControl'

interface PackageSortControlWrapperProps {
    value: HolidayPackageSort
    onChange: (value: HolidayPackageSort) => void
    isMobile: boolean
}

const PackageSortControlWrapper: React.FC<PackageSortControlWrapperProps> = ({ value, onChange, isMobile }) => {
    const t = useTranslations('holidaysPage')

    const options: PackageSortOption[] = [
        { value: HOLIDAY_PACKAGE_SORT.PRICE_LOW_TO_HIGH, label: t('sortPriceLowToHigh') },
        { value: HOLIDAY_PACKAGE_SORT.PRICE_HIGH_TO_LOW, label: t('sortPriceHighToLow') },
        { value: HOLIDAY_PACKAGE_SORT.NAME, label: t('sortAToZ') }
    ]
    const activeLabel = options.find(option => option.value === value)?.label ?? options[0].label

    return (
        <PackageSortControl
            sortByLabel={t('sortBy')}
            activeLabel={activeLabel}
            activeValue={value}
            options={options}
            onChange={onChange}
            isMobile={isMobile}
        />
    )
}

export { PackageSortControlWrapper }
export default PackageSortControlWrapper
